import { render, staticRenderFns } from "./televalua.vue?vue&type=template&id=66daffde&"
import script from "./televalua.vue?vue&type=script&lang=js&"
export * from "./televalua.vue?vue&type=script&lang=js&"
import style0 from "./televalua.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports